export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Lunes.f50d4ab7.png";